"use client"
import { Link } from "react-router"

function Footer() {
  return (
    <footer className="pt-5 pb-3 text-center">
      <div className="flex items-center justify-center gap-4 mb-2">
        <Link className="link-button" target="_blank" to={'https://kaxaa.com/terms-condition/'}>Terms & Condition</Link>
        <span className="text-secondary opacity-50">|</span>
        <Link className="link-button" target="_blank" to={'https://kaxaa.com/privacy-policy/'}>Privacy Policy</Link>
      </div>
      <p className="m-0 text-secondary">Powered by kaxaa.com</p>
    </footer>
  )
}

export default Footer
